var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326.76 323.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_10",
    "data-name": "Calque 10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "244.2 241.04 140.88 192.87 208.31 48.24 311.63 96.37 244.2 241.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.64,16.7c22.28,10.65,30.7,37.26,18.54,58.97l-103.08-48.04c8.57-23.49,35.43-34.34,58-23.28l26.53,12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.14,305.53c-3.55,2.4-7.89,2.67-11.49.88-2.44-1.21-5.84-4.09-6.25-8.01l-8.67-82.76,94.23,43.99-67.82,45.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.08,323.81l-38.93.06c-18.71.03-33.61-15.07-33.92-33.67-.11-6.73-4.87-11.88-11.71-11.88H11.59c-6.53-.02-11.49-5.1-11.59-11.24s4.88-11.59,11.6-11.58l29.96.02c19.01.01,34.14,15.01,34.39,33.95.09,6.81,5.19,11.64,11.9,11.65l37.71.02c6.25,0,10.94,5.19,11.18,10.95.23,5.52-4.07,11.73-10.68,11.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.38d196a0cdff19d3a1939945b4068059.svg";
export { ForwardRef as ReactComponent };